var _rect, _rect2, _path, _rect3, _rect4, _rect5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItemLayoutCenterPriceTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 58,
    viewBox: "0 0 118 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 58,
    rx: 5,
    fill: "#EAEAEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 29.5,
    y: 16,
    width: 49,
    height: 4,
    rx: 1.5,
    fill: "#B4B3B3",
    stroke: "#939393"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.3643 12.7529V14.2129H85.6123V12.7529H86.3643ZM86.2715 20.7266V22.0352H85.5244V20.7266H86.2715ZM87.0088 19.1494C87.0088 18.9606 86.9697 18.7962 86.8916 18.6562C86.8167 18.513 86.693 18.3844 86.5205 18.2705C86.348 18.1533 86.1169 18.0443 85.8271 17.9434C85.4105 17.7969 85.0459 17.6325 84.7334 17.4502C84.4242 17.2646 84.1833 17.0368 84.0107 16.7666C83.8415 16.4932 83.7568 16.153 83.7568 15.7461C83.7568 15.3457 83.848 14.999 84.0303 14.7061C84.2158 14.4131 84.473 14.1868 84.8018 14.0273C85.1305 13.8678 85.5146 13.7881 85.9541 13.7881C86.2926 13.7881 86.597 13.8385 86.8672 13.9395C87.1406 14.0404 87.3734 14.1885 87.5654 14.3838C87.7575 14.5791 87.904 14.82 88.0049 15.1064C88.109 15.3896 88.1611 15.7152 88.1611 16.083H86.9893C86.9893 15.8747 86.9648 15.6891 86.916 15.5264C86.8704 15.3604 86.8021 15.2204 86.7109 15.1064C86.6198 14.9893 86.5091 14.8997 86.3789 14.8379C86.252 14.776 86.1071 14.7451 85.9443 14.7451C85.7132 14.7451 85.5228 14.7891 85.373 14.877C85.2233 14.9616 85.1126 15.0788 85.041 15.2285C84.9727 15.3783 84.9385 15.5492 84.9385 15.7412C84.9385 15.9268 84.9743 16.0895 85.0459 16.2295C85.1175 16.3695 85.2396 16.4964 85.4121 16.6104C85.5879 16.721 85.8288 16.8333 86.1348 16.9473C86.5547 17.097 86.9176 17.2646 87.2236 17.4502C87.5329 17.6325 87.7705 17.8587 87.9365 18.1289C88.1058 18.3958 88.1904 18.7327 88.1904 19.1396C88.1904 19.5596 88.0928 19.916 87.8975 20.209C87.7054 20.502 87.4352 20.7249 87.0869 20.8779C86.7419 21.0277 86.3398 21.1025 85.8809 21.1025C85.5911 21.1025 85.3031 21.0651 85.0166 20.9902C84.7334 20.9121 84.4762 20.7852 84.2451 20.6094C84.014 20.4336 83.8301 20.2008 83.6934 19.9111C83.5566 19.6182 83.4883 19.2601 83.4883 18.8369H84.6699C84.6699 19.0908 84.7041 19.3024 84.7725 19.4717C84.8408 19.641 84.9336 19.7744 85.0508 19.8721C85.168 19.9697 85.2982 20.0397 85.4414 20.082C85.5879 20.1243 85.7344 20.1455 85.8809 20.1455C86.125 20.1455 86.3301 20.1048 86.4961 20.0234C86.6654 19.9388 86.7923 19.8216 86.877 19.6719C86.9648 19.5189 87.0088 19.3447 87.0088 19.1494Z",
    fill: "#3A3A3A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 26.5,
    width: 93,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 37.5,
    width: 63,
    height: 4,
    rx: 1.5,
    fill: "#D3D3D3",
    stroke: "#FAFAFA"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 117,
    height: 57,
    rx: 4.5,
    stroke: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemLayoutCenterPriceTop);
export default __webpack_public_path__ + "static/media/ItemLayoutCenterPriceTop.be5966318bbec31834179fe38ea14fff.svg";
export { ForwardRef as ReactComponent };